module.exports = __webpack_public_path__ + "img/nolist.47d776df.png";